module.exports = __webpack_public_path__ + "img/mail.2028b455.png";